import React, {useCallback, useEffect, useState} from "react";
import api from "../../api/client";
import {useNavigate, useParams} from "react-router-dom";
import LoadingInside from "../../components/Loading/LoadingInside";
import LocationScroller from "../../components/LocationScroller/LocationScroller";
import TourHorizontalScroller from "../../components/TourHorizontalScroller/TourHorizontalScroller";
import SeoMeta from "../../components/SeoMeta";
import s from "./ToursByLocation.module.scss";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import titleImage from "../../assets/images/titleImage.png";
import ComboHorizontalScroller from "../../components/ComboHorizontalScroller/ComboHorizontalScroller";

const apiUrl = process.env.REACT_APP_API_URL;
const ToursByLocation = () => {
    const {slug} = useParams();
    const navigate = useNavigate();
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [tours, setTours] = useState([]);
    const [loadingLocations, setLoadingLocations] = useState(true);
    const [loadingTours, setLoadingTours] = useState(false);
    const [combos, setCombos] = useState([]);
    const [loadingCombos, setLoadingCombos] = useState(false);
    const breadcrumbItems = [
        {name: "ホーム", link: "/"},
        {name: slug}
    ];

    const [tourPage,setTourPage] = useState(1);
    const [hasMoreTours,setHasMoreTours] = useState(true);
    const [loadingMoreTours,setLoadingMoreTours] = useState(false);
    const [comboPage,setComboPage]=useState(1);
    const [hasMoreCombos,setHasMoreCombos] = useState(true);
    const [loadingMoreCombos,setLoadingMoreCombos] = useState(false);

    /*
            Load locations
                */
    useEffect(() => {
        api.get(`${apiUrl}/api/locations`)
            .then(res => {
                const data =
                    res.data.data || res.data;
                setLocations(data);
                let location;
                if (slug) {
                    location = data.find(
                        item =>
                            item.slug === slug
                    );
                }
                if (!location) {
                    location = data[0];
                }
                if (location) {
                    setSelectedLocation(location);
                }
            })
            .finally(() => {
                setLoadingLocations(false);
            });
    }, [slug]);

    /*
            Load tours
                */
    useEffect(() => {
        loadTours(1,true);
    }, [selectedLocation]);

    const loadTours = async (
        page = 1,
        reset = false
    )=>{
        if(loadingMoreTours) return;
        setLoadingMoreTours(true);

        try{
            const res = await api.get(
                `${apiUrl}/api/search`,
                {
                    params:{
                        location:
                        selectedLocation.id,
                        page:page
                    }
                }
            );
            const newTours =
                res.data.data || [];
            if(reset){
                setTours(newTours);
            }else{
                setTours(prev=>[
                    ...prev,
                    ...newTours
                ]);
            }
            setHasMoreTours(newTours.length > 0);
            setTourPage(page);
        }
        finally{
            setLoadingMoreTours(false);
        }
    };

    const loadCombos = useCallback(async (
        page = 1,
        reset = false
    ) => {
        if (loadingMoreCombos) return;

        if(reset){
            setLoadingCombos(true);
        }else{
            setLoadingMoreCombos(true);
        }

        try {

            const params = {
                multi_city:true,
                page
            };

            if(selectedLocation){
                params.location =
                    selectedLocation;
            }

            const res = await api.get(
                `${apiUrl}/api/combos`,
                {
                    params
                }
            );

            const data = res.data.data || res.data || [];

            if(reset){
                setCombos(data);
            }else{
                setCombos(prev=>[
                    ...prev,
                    ...data
                ]);
            }

            setHasMoreCombos(data.length > 0);
            setComboPage(page);
        }
        finally{
            setLoadingCombos(false);
            setLoadingMoreCombos(false);
        }

    },[
        selectedLocation,
        loadingMoreCombos
    ]);
    useEffect(() => {

        loadCombos(1,true);

    },[selectedLocation]);


    const changeLocation = (location) => {
        setSelectedLocation(location);
        navigate(
            `/tours/location/${location.slug}`
        );
    };
    if (loadingLocations) {
        return (
            <LoadingInside height="50vh"/>
        );
    }
    return (
        <>
            <SeoMeta
                slug={
                    window.location.pathname
                }
                fallback={{
                    title:
                        selectedLocation
                            ? `${selectedLocation.name} Tours`
                            : "Tours",
                    description:
                        selectedLocation
                            ? `${selectedLocation.name} sightseeing tours`
                            : "Tours"
                }}
            />
            <div className={s.page}>
                {/* TITLE */}
                <div className="row mt-3 mb-3">
                    <div className="col-12">
                        <Breadcrumb items={breadcrumbItems}/>
                        <div className={s.titleWrrapper}>
                            <img className={s.titleImage} src={titleImage}/>
                            <h2 className={s.primaryTitle}>オーストラリア全土のツアー</h2>
                            <h3 className={s.secondaryTitle}>Tour Introduction</h3>
                        </div>
                    </div>
                </div>
                <LocationScroller
                    locations={locations}
                    selected={selectedLocation}
                    onSelect={changeLocation}
                />
                <div className={s.tourArea}>
                    <h3>
                        {selectedLocation?.name}
                        <span>
                            Tours
                        </span>
                    </h3>
                    {
                        loadingTours
                            ?
                            <LoadingInside
                                height="40vh"
                            />
                            :
                            <TourHorizontalScroller
                                tours={tours}
                                loadMore={()=>loadTours(tourPage+1)}
                                hasMore={hasMoreTours}
                                loading={loadingMoreTours}
                            />
                    }
                </div>

                {combos?.length > 0 && (
                    <div className={s.tourArea}>
                        <h3>
                            2つの都市お得なセット
                            <span>Combo Deals</span>
                        </h3>

                        {loadingCombos ? (
                            <LoadingInside height="40vh" />
                        ) : (
                            <ComboHorizontalScroller
                                combos={combos}
                                loadMore={()=>
                                    loadCombos(comboPage+1)
                                }
                                hasMore={hasMoreCombos}
                                loading={loadingMoreCombos}
                            />
                        )}
                    </div>
                )}
            </div>
        </>
    );
};
export default ToursByLocation;